import React from "react";
import PropTypes from "prop-types";
import { Box, Grid, Card, Typography, Button } from "@mui/material";
import { Icon } from "@iconify/react";

const DoneStep = ({
  showAllSetBanner,
  hideAddMoreCentres,
  onAddMoreCentres,
  onAddTeam,
  onDoLater,
}) => (
  <div
    style={{
      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
    }}
  >
    {showAllSetBanner && (
      <Box textAlign="center" sx={{ mb: 4 }}>
        <Icon
          icon="icon-park-solid:check-one"
          width="82"
          height="82"
          style={{ color: "#068F06" }}
        />
        <Typography
          variant="h4"
          fontWeight={700}
          mt={2}
          sx={{ fontSize: { xs: 26, sm: 34 } }}
        >
          You are all set!
        </Typography>
        <Typography sx={{ maxWidth: 640, mt: 1 }}>
          Your organisation and first centre have been successfully added.
          Here’s what more you can do with Spandan One
        </Typography>
      </Box>
    )}

    {/* ACTION CARDS */}
    <Grid
      container
      spacing={{ xs: 2, md: 4 }}
      sx={{
        width: "100%",
        flexDirection: "row",
        display: "flex",
      }}
    >
      {/* Add More Centres */}
      {!hideAddMoreCentres && (
      <Grid size={{ xs: 12, md: 6 }}>
        <Card
          onClick={onAddMoreCentres}
          sx={{
            p: 2,
            minHeight: { xs: "auto", md: 292 },
            borderRadius: 3,
            backgroundColor: "#FFF6E9",
            cursor: "pointer",
            position: "relative",
            boxShadow: "none",
            transition: "all 0.2s ease",
            "&:hover": {
              boxShadow: "var(--app-shadow)",
            },
          }}
        >
          <Box
            sx={{
              width: 50,
              height: 50,
              borderRadius: "50%",
              backgroundColor: "var(--app-surface)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mb: 2,
            }}
          >
            <Icon
              icon="fluent:home-add-20-filled"
              width="28"
              height="28"
              color="#F0991F"
            />
          </Box>

          <Typography
            fontWeight={700}
            mb={1}
            sx={{ fontSize: { xs: 18, md: 22 } }}
          >
            Add More Centres
          </Typography>

          <Typography sx={{ fontSize: { xs: 14, md: 16 }, lineHeight: "26px", pr: 5 }}>
            Running more than one centre? That could be different branches or
            locations, just add them here to keep everything in one place.
          </Typography>

          <Icon
            icon="ic:baseline-chevron-right"
            width="36"
            height="36"
            style={{
              position: "absolute",
              top: "50%",
              right: 16,
              transform: "translateY(-50%)",
              color: "rgba(0,0,0,0.5)",
            }}
          />
        </Card>
      </Grid>
      )}

      {/* Add Your Team */}
      <Grid size={{ xs: 12, md: hideAddMoreCentres ? 12 : 6 }}>
        <Card
          onClick={onAddTeam}
          sx={{
            p: 2,
            minHeight: { xs: "auto", md: 292 },
            borderRadius: 3,
            backgroundColor: "#F4F6FF",
            cursor: "pointer",
            position: "relative",
            boxShadow: "none",
            transition: "all 0.2s ease",
            "&:hover": {
              boxShadow: "var(--app-shadow)",
            },
          }}
        >
          <Box
            sx={{
              width: 50,
              height: 50,
              borderRadius: "50%",
              backgroundColor: "var(--app-surface)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mb: 2,
            }}
          >
            <Icon icon="solar:user-bold" width="28" height="28" color="#5751E9" />
          </Box>

          <Typography
            fontWeight={700}
            mb={1}
            sx={{ fontSize: { xs: 18, md: 22 } }}
          >
            Add your Team
          </Typography>

          <Typography sx={{ fontSize: { xs: 14, md: 16 }, lineHeight: "26px", pr: 5 }}>
            Need to add team members? You can invite them and set their roles
            to control what they can access and manage.
          </Typography>

          <Icon
            icon="ic:baseline-chevron-right"
            width="36"
            height="36"
            style={{
              position: "absolute",
              top: "50%",
              right: 16,
              transform: "translateY(-50%)",
              color: "rgba(0,0,0,0.5)",
            }}
          />
        </Card>
      </Grid>
    </Grid>

    {/* DO LATER */}
    <Box sx={{ mt: 4, width: { xs: "100%", sm: "auto" } }}>
      <Button
        onClick={onDoLater}
        variant="contained"
        sx={{
          backgroundColor: "#F4F6FF",
          color: "#5B5AFB",
          width: { xs: "100%", sm: 240 },
          height: 48,
          borderRadius: 2,
          fontWeight: 600,
          textTransform: "none",
          boxShadow: "none",
          "&:hover": {
            backgroundColor: "#EEF1FF",
            boxShadow: "none",
          },
        }}
      >
        I’ll do it Later
      </Button>
    </Box>
  </div>
);

DoneStep.propTypes = {
  showAllSetBanner: PropTypes.bool,
  hideAddMoreCentres: PropTypes.bool,
  onAddMoreCentres: PropTypes.func.isRequired,
  onAddTeam: PropTypes.func.isRequired,
  onDoLater: PropTypes.func.isRequired,
};

export default DoneStep;
